import { LinkOutlined } from "@ant-design/icons";

export const MiniCatalogLink = ({ id }) => {
  return (
	<span>
		<strong>{id ? id : 'N/A'}</strong>&nbsp;
		{id && <a target="_blank" href={`https://mini-catalogue.entertainment-intelligence.com/products/${id}`}>
			<LinkOutlined />
		</a>}
	</span>
  )
}